module.exports = __webpack_public_path__ + "static/lunchtype23-regular-italic-webfont-9f3ab47c888e285d8a6ad021b00bfbde.woff";